import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { UserRoleManagement } from "./UserRoleManagement";
import { FeatureFlagRoleBindings } from "./FeatureFlagRoleBindings";

export default function AdminPage() {
    return (
        <ProtectedRoute requiredRole="Admin">
            <div className="flex flex-col gap-6">
                <UserRoleManagement />
                <FeatureFlagRoleBindings />
            </div>
        </ProtectedRoute>
    );
}
